module.exports = __webpack_public_path__ + "static/media/portfolio-example-08.e5dc1d6f.jpg";